import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d94b9154")

_pushScopeId("data-v-d94b9154")
const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = {
  key: 1,
  class: "row justify-content-center align-items-center authentication authentication-basic h-100vh"
}
const _hoisted_4 = { class: "col-xl-5 col-lg-7 col-md-7 col-sm-8 col-12" }
const _hoisted_5 = { class: "card custom-card my-4" }
const _hoisted_6 = { class: "card-body p-0" }
const _hoisted_7 = { class: "logo-wrap" }
const _hoisted_8 = { href: "#" }
const _hoisted_9 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_10 = { class: "login-tab-wrap" }
const _hoisted_11 = {
  class: "nav nav-tabs justify-content-center",
  id: "nav-tab",
  role: "tablist"
}
const _hoisted_12 = {
  class: "tab-content",
  id: "nav-tabContent"
}
const _hoisted_13 = {
  class: "tab-pane fade show active",
  id: "nav-login",
  role: "tabpanel",
  "aria-labelledby": "nav-login-tab"
}
const _hoisted_14 = {
  class: "p-3",
  id: "f1_container"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("input", {
  type: "checkbox",
  id: "ossm",
  name: "ossm",
  class: "ossm-input",
  "data-gtm-form-interact-field-id": "2"
}, null, -1)
const _hoisted_16 = { id: "f1_card" }
const _hoisted_17 = { class: "front face" }
const _hoisted_18 = { class: "login-header d-block mb-3" }
const _hoisted_19 = { class: "text-muted" }
const _hoisted_20 = { class: "form-wrap pt-0" }
const _hoisted_21 = {
  "form-wrap": "",
  "pt-0": ""
}
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { for: "fname" }
const _hoisted_24 = { class: "input-with-icon" }
const _hoisted_25 = {
  key: 0,
  class: "input-icon"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("i", { class: "fa fa-pencil-alt" }, null, -1)
const _hoisted_27 = {
  key: 0,
  class: "alert alert-danger mt-2"
}
const _hoisted_28 = {
  role: "alert",
  "aria-live": "assertive"
}
const _hoisted_29 = {
  key: 0,
  class: "btn-wrap mb-5 pt-0"
}
const _hoisted_30 = {
  key: 1,
  class: "form-group"
}
const _hoisted_31 = { for: "fname" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-8" }
const _hoisted_34 = { class: "col-4" }
const _hoisted_35 = {
  key: 0,
  class: "alert alert-warning text-center mt-2"
}
const _hoisted_36 = { key: 0 }
const _hoisted_37 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_38 = { key: 1 }
const _hoisted_39 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_41 = {
  key: 1,
  class: "text-center"
}
const _hoisted_42 = { class: "my-4" }
const _hoisted_43 = { class: "or-col text-center" }
const _hoisted_44 = { class: "inline-items text-center" }
const _hoisted_45 = /*#__PURE__*/_createVNode("li", { class: "mr-2" }, [
  /*#__PURE__*/_createVNode("div", {
    id: "googleSignInDiv",
    class: "g-signin2",
    "data-onsuccess": "onSignIn"
  })
], -1)
const _hoisted_46 = { class: "back face center" }
const _hoisted_47 = { class: "login-header d-block mb-3" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { key: 2 }
const _hoisted_51 = { class: "form-wrap pt-0" }
const _hoisted_52 = {
  key: 0,
  class: "initial-screen"
}
const _hoisted_53 = { class: "form-group" }
const _hoisted_54 = { for: "fname" }
const _hoisted_55 = { class: "input-with-icon" }
const _hoisted_56 = {
  key: 0,
  class: "input-icon"
}
const _hoisted_57 = /*#__PURE__*/_createVNode("i", { class: "fa fa-pencil-alt" }, null, -1)
const _hoisted_58 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_59 = {
  key: 0,
  class: "form-group mb-3"
}
const _hoisted_60 = {
  key: 1,
  class: "otp-screen"
}
const _hoisted_61 = { class: "form-group mb-3" }
const _hoisted_62 = { for: "fname" }
const _hoisted_63 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_64 = {
  key: 0,
  class: "alert alert-success text-center"
}
const _hoisted_65 = /*#__PURE__*/_createVNode("i", { class: "fa fa-check-double" }, null, -1)
const _hoisted_66 = { class: "alert alert-warning text-center" }
const _hoisted_67 = { key: 0 }
const _hoisted_68 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_69 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_70 = { key: 1 }
const _hoisted_71 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_72 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_73 = { class: "text-center" }
const _hoisted_74 = { class: "my-4" }
const _hoisted_75 = {
  key: 2,
  class: "alert alert-danger"
}
const _hoisted_76 = { key: 3 }
const _hoisted_77 = { class: "form-group" }
const _hoisted_78 = { for: "fname" }
const _hoisted_79 = { class: "input-with-icon" }
const _hoisted_80 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_81 = {
  key: 0,
  class: "text-center"
}
const _hoisted_82 = {
  key: 4,
  class: "otp-screen"
}
const _hoisted_83 = {
  key: 0,
  class: "alert alert-success text-center"
}
const _hoisted_84 = /*#__PURE__*/_createVNode("i", { class: "fa fa-check-double" }, null, -1)
const _hoisted_85 = { class: "text-center" }
const _hoisted_86 = { class: "or-col" }
const _hoisted_87 = {
  for: "ossm",
  class: "onclick-text btn default-btn outline"
}
const _hoisted_88 = {
  class: "tab-pane fade",
  id: "nav-Create",
  role: "tabpanel",
  "aria-labelledby": "nav-Create-tab"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_AppEmailAndPhoneNumberValidate = _resolveComponent("AppEmailAndPhoneNumberValidate")
  const _component_AppOTPInput = _resolveComponent("AppOTPInput")
  const _component_CounterComponent = _resolveComponent("CounterComponent")
  const _component_SignUpWithOtp = _resolveComponent("SignUpWithOtp")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.state.ui.postLoading.tokenLogin)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("a", _hoisted_8, [
                    _createVNode("img", {
                      class: "img-logo-big",
                      src: _ctx.state.imageBaseUrl
              ? `${_ctx.state.imageBaseUrl}img/logo.png`
              : 'img/logo.png'
              ,
                      alt: ""
                    }, null, 8, ["src"])
                  ])
                ]),
                _hoisted_9,
                _createVNode("div", _hoisted_10, [
                  _createVNode("nav", null, [
                    _createVNode("div", _hoisted_11, [
                      _createVNode("button", {
                        class: "nav-link active",
                        id: "nav-login-tab",
                        "data-toggle": "tab",
                        "data-target": "#nav-login",
                        type: "button",
                        role: "tab",
                        "aria-controls": "nav-login",
                        "aria-selected": "true",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setActiveTab('login')))
                      }, _toDisplayString(_ctx.$t('login')), 1),
                      _createVNode("button", {
                        class: "nav-link",
                        id: "nav-Create-tab",
                        "data-toggle": "tab",
                        "data-target": "#nav-Create",
                        type: "button",
                        role: "tab",
                        "aria-controls": "nav-Create",
                        "aria-selected": "false",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setActiveTab('create-account')))
                      }, _toDisplayString(_ctx.$t('create_account')), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_12, [
                    _createVNode("div", _hoisted_13, [
                      _createVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _createVNode("div", _hoisted_16, [
                          _createVNode("div", _hoisted_17, [
                            _createVNode("div", _hoisted_18, [
                              _createVNode("h1", null, _toDisplayString(_ctx.$t('sign_in_to_account')), 1),
                              _createVNode("p", _hoisted_19, _toDisplayString(_ctx.$t('enter_email_mobile_number_to_login')), 1)
                            ]),
                            _createVNode("div", _hoisted_20, [
                              _createVNode(_component_ErrorList, {
                                errors: _ctx.state.ui.error.errorList.loginToAccount,
                                hasError: _ctx.state.ui.error.hasError
                              }, null, 8, ["errors", "hasError"]),
                              _createVNode("div", _hoisted_21, [
                                _createVNode("div", _hoisted_22, [
                                  _createVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('email_phone')) + ":", 1),
                                  _createVNode("div", _hoisted_24, [
                                    _createVNode(_component_AppEmailAndPhoneNumberValidate, {
                                      clear: _ctx.clearInputValue,
                                      onUpdateInput: _ctx.handleInput,
                                      onEmitError: _ctx.handleError,
                                      disabled: _ctx.state.ui.disabled.primary,
                                      onClearInput: _ctx.handleClear,
                                      onValidationResult: _ctx.handleValidationResult
                                    }, null, 8, ["clear", "onUpdateInput", "onEmitError", "disabled", "onClearInput", "onValidationResult"]),
                                    (_ctx.state.ui.showUI.changeInput)
                                      ? (_openBlock(), _createBlock("div", _hoisted_25, [
                                          _createVNode("a", {
                                            title: "edit",
                                            href: "javascript:void(0)",
                                            class: "change-text",
                                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.dataClear && _ctx.dataClear(...args)))
                                          }, [
                                            _hoisted_26,
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('change')), 1)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                (_ctx.errorMessage)
                                  ? (_openBlock(), _createBlock("div", _hoisted_27, [
                                      _createVNode("p", _hoisted_28, _toDisplayString(_ctx.errorMessage), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              (!_ctx.state.ui.showUI.changeInput && !_ctx.state.ui.showUI.counter)
                                ? (_openBlock(), _createBlock("div", _hoisted_29, [
                                    _createVNode("a", {
                                      class: "btn d-block button-gradient",
                                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.getOTPForLogin && _ctx.getOTPForLogin(...args)))
                                    }, _toDisplayString(_ctx.$t('get_otp_to_login')), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.state.ui.showUI.counter)
                                ? (_openBlock(), _createBlock("div", _hoisted_30, [
                                    _createVNode("label", _hoisted_31, _toDisplayString(_ctx.$t('enter_otp_here')) + ":", 1),
                                    _createVNode("div", _hoisted_32, [
                                      _createVNode("div", _hoisted_33, [
                                        _createVNode(_component_AppOTPInput, { onSixDigitInput: _ctx.handleSixDigitOTP }, null, 8, ["onSixDigitInput"])
                                      ]),
                                      _createVNode("div", _hoisted_34, [
                                        (_ctx.state.ui.showUI.counter && !_ctx.state.ui.showUI.resendOTP)
                                          ? (_openBlock(), _createBlock(_component_CounterComponent, {
                                              key: 0,
                                              initialTime: _ctx.state.data.setCounter,
                                              onUpdateStatus: _ctx.handleStatusUpdate
                                            }, null, 8, ["initialTime", "onUpdateStatus"]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    (!_ctx.state.ui.showUI.resendOTP)
                                      ? (_openBlock(), _createBlock("div", _hoisted_35, [
                                          (!_ctx.state.data.isPrimaryEmail)
                                            ? (_openBlock(), _createBlock("p", _hoisted_36, [
                                                _hoisted_37,
                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('passcode_sent_phone')) + " ", 1),
                                                _createVNode("strong", null, _toDisplayString(_ctx.enteredValue) + ".", 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.state.data.isPrimaryEmail)
                                            ? (_openBlock(), _createBlock("p", _hoisted_38, [
                                                _hoisted_39,
                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('passcode_sent_email')) + " ", 1),
                                                _createVNode("strong", null, _toDisplayString(_ctx.enteredValue), 1),
                                                _hoisted_40
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.state.ui.showUI.resendOTP)
                                      ? (_openBlock(), _createBlock("div", _hoisted_41, [
                                          _createVNode("p", _hoisted_42, [
                                            _createTextVNode(_toDisplayString(_ctx.$t('didnt_get_code')) + " ", 1),
                                            _createVNode("a", {
                                              href: "javascript:void(0)",
                                              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.getOTPForLogin && _ctx.getOTPForLogin(...args)))
                                            }, [
                                              _createVNode("strong", null, _toDisplayString(_ctx.$t('resend_again')), 1)
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("div", _hoisted_43, [
                                _createVNode("span", null, _toDisplayString(_ctx.$t('or')), 1)
                              ]),
                              _createVNode("div", _hoisted_44, [
                                _createVNode("ul", null, [
                                  _hoisted_45,
                                  _createVNode("li", null, [
                                    _createVNode("label", {
                                      for: "ossm",
                                      class: "onclick-text btn default-btn text-white",
                                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.showGetInviationLink && _ctx.showGetInviationLink(...args)))
                                    }, _toDisplayString(_ctx.$t('login_with_invited_link')), 1)
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_46, [
                            _createVNode("div", _hoisted_47, [
                              (_ctx.state.invitationLinks.show)
                                ? (_openBlock(), _createBlock("h1", _hoisted_48, _toDisplayString(_ctx.$t('get_invitation_link')), 1))
                                : (!_ctx.state.invitationLinks.show)
                                  ? (_openBlock(), _createBlock("h1", _hoisted_49, _toDisplayString(_ctx.$t('get_otp')), 1))
                                  : (_openBlock(), _createBlock("h1", _hoisted_50, _toDisplayString(_ctx.$t('sign_in_without_password')), 1))
                            ]),
                            _createVNode("div", _hoisted_51, [
                              (!_ctx.state.invitationLinks.show)
                                ? (_openBlock(), _createBlock("div", _hoisted_52, [
                                    _createVNode("div", _hoisted_53, [
                                      _createVNode("label", _hoisted_54, _toDisplayString(_ctx.$t('email')) + ":", 1),
                                      _createVNode("div", _hoisted_55, [
                                        _withDirectives(_createVNode("input", {
                                          type: "email",
                                          id: "email",
                                          name: "email",
                                          class: "form-control",
                                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.passCode.email = $event)),
                                          disabled: _ctx.state.passCode.isSendOtp || _ctx.state.passCode.showButton
                                        }, null, 8, ["disabled"]), [
                                          [_vModelText, _ctx.state.passCode.email]
                                        ]),
                                        (_ctx.state.passCode.isSendOtp || _ctx.state.passCode.showButton)
                                          ? (_openBlock(), _createBlock("div", _hoisted_56, [
                                              _createVNode("a", {
                                                title: "edit",
                                                href: "javascript:void(0)",
                                                class: "change-text",
                                                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.dataClear && _ctx.dataClear(...args)))
                                              }, [
                                                _hoisted_57,
                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('change')), 1)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      (_ctx.state.passCode.error.length)
                                        ? (_openBlock(), _createBlock("p", _hoisted_58, _toDisplayString(_ctx.state.passCode.error[0]), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (!_ctx.state.passCode.showButton && !_ctx.state.passCode.isSendOtp)
                                      ? (_openBlock(), _createBlock("div", _hoisted_59, [
                                          _createVNode("button", {
                                            type: "submit",
                                            class: "default-btn btn btn-block h-100 py-3",
                                            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.sendOtp && _ctx.sendOtp(...args)))
                                          }, _toDisplayString(_ctx.$t('send')), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.state.passCode.isSendOtp)
                                ? (_openBlock(), _createBlock("div", _hoisted_60, [
                                    _createVNode("div", _hoisted_61, [
                                      _createVNode("label", _hoisted_62, _toDisplayString(_ctx.$t('enter_pass_code')) + ":", 1),
                                      _withDirectives(_createVNode("input", {
                                        type: "text",
                                        id: "otp",
                                        name: "otp",
                                        class: "form-control",
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.state.passCode.otp = $event)),
                                        onKeyup: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.checkOtp && _ctx.checkOtp(...args)))
                                      }, null, 544), [
                                        [_vModelText, _ctx.state.passCode.otp]
                                      ]),
                                      (_ctx.state.passCode.errorLogin.length)
                                        ? (_openBlock(), _createBlock("p", _hoisted_63, _toDisplayString(_ctx.state.passCode.errorLogin[0]), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (_ctx.state.passCode.successMessage)
                                      ? (_openBlock(), _createBlock("div", _hoisted_64, [
                                          _createVNode("p", null, [
                                            _hoisted_65,
                                            _createTextVNode(_toDisplayString(_ctx.state.passCode.successMessage), 1)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createVNode("div", _hoisted_66, [
                                      (_ctx.state.passCode.resEmail && _ctx.state.passCode.resMobile)
                                        ? (_openBlock(), _createBlock("p", _hoisted_67, [
                                            _hoisted_68,
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('passcode_sent_phone')) + " ", 1),
                                            _createVNode("strong", null, _toDisplayString(_ctx.state.passCode.resMobile), 1),
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('and_email_address')) + " ", 1),
                                            _createVNode("strong", null, _toDisplayString(_ctx.enteredValue), 1),
                                            _hoisted_69
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.state.passCode.resEmail && !_ctx.state.passCode.resMobile)
                                        ? (_openBlock(), _createBlock("p", _hoisted_70, [
                                            _hoisted_71,
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('passcode_sent_email')) + " ", 1),
                                            _createVNode("strong", null, _toDisplayString(_ctx.enteredValue), 1),
                                            _hoisted_72
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createVNode("div", _hoisted_73, [
                                      _createVNode("p", _hoisted_74, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('didnt_get_code')) + " ", 1),
                                        _createVNode("a", {
                                          href: "javascript:void(0)",
                                          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.sendOtp && _ctx.sendOtp(...args)))
                                        }, [
                                          _createVNode("strong", null, _toDisplayString(_ctx.$t('resend_again')), 1)
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.state.passCode.error[0] === 'User is not verified yet.')
                                ? (_openBlock(), _createBlock("div", _hoisted_75, [
                                    _createVNode("p", null, [
                                      _createTextVNode(_toDisplayString(_ctx.$t('didnt_get_verification_email')) + " ", 1),
                                      _createVNode("a", {
                                        href: "javascript:void(0)",
                                        onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.resendMail && _ctx.resendMail(...args)))
                                      }, [
                                        _createVNode("strong", null, _toDisplayString(_ctx.$t('resend_again')), 1)
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.state.invitationLinks.show)
                                ? (_openBlock(), _createBlock("div", _hoisted_76, [
                                    _createVNode("div", _hoisted_77, [
                                      _createVNode("label", _hoisted_78, _toDisplayString(_ctx.$t('email_phone')) + ":", 1),
                                      _createVNode("div", _hoisted_79, [
                                        _createVNode(_component_AppEmailAndPhoneNumberValidate, {
                                          clear: _ctx.clearInputValue,
                                          onUpdateInput: _ctx.handleInput,
                                          onEmitError: _ctx.handleError,
                                          disabled: _ctx.state.ui.disabled.primary,
                                          onClearInput: _ctx.handleClear,
                                          onValidationResult: _ctx.handleValidationResult
                                        }, null, 8, ["clear", "onUpdateInput", "onEmitError", "disabled", "onClearInput", "onValidationResult"])
                                      ]),
                                      (_ctx.state.passCode.error.length)
                                        ? (_openBlock(), _createBlock("p", _hoisted_80, _toDisplayString(_ctx.state.passCode.error[0]), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (_ctx.state.invitationLinks.show && !_ctx.state.invitationLinks.isSent)
                                      ? (_openBlock(), _createBlock("div", _hoisted_81, [
                                          _createVNode("button", {
                                            type: "submit",
                                            class: "default-btn btn btn-block h-100 py-3",
                                            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.sendTokenLinks && _ctx.sendTokenLinks(...args)))
                                          }, _toDisplayString(_ctx.$t('send')), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.state.invitationLinks.isSent)
                                ? (_openBlock(), _createBlock("div", _hoisted_82, [
                                    (_ctx.state.invitationLinks.successMessage)
                                      ? (_openBlock(), _createBlock("div", _hoisted_83, [
                                          _createVNode("p", null, [
                                            _hoisted_84,
                                            _createTextVNode(_toDisplayString(_ctx.state.invitationLinks.successMessage), 1)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("div", _hoisted_85, [
                                _createVNode("div", _hoisted_86, [
                                  _createVNode("span", null, _toDisplayString(_ctx.$t('or')), 1)
                                ]),
                                _createVNode("label", _hoisted_87, _toDisplayString(_ctx.$t('login_with_otp')), 1)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_88, [
                      (_ctx.state.data.activeTab === 'create-account')
                        ? (_openBlock(), _createBlock(_component_SignUpWithOtp, {
                            key: 0,
                            onRegistrationSuccess: _ctx.registrationSuccess,
                            tab: _ctx.state.data.activeTab
                          }, null, 8, ["onRegistrationSuccess", "tab"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
  ]))
})